<!-----------------------------------------------------------------------------
  Copyright (c) 2016 - 2021.                                                  -
  Yega Yazilim ve Bilisim Hizmetleri Dis Tic Ltd Sti (Yega Yazilim)           -
  All Rights Reserved.                                                        -
                                                                              -
  The software and data contained herein are confidential and proprietary     -
  information of Yega Yazilim ("Confidential Information").                   -
                                                                              -
  Users of this software may not disclose such Confidential Information and   -
  shall use it only in accordance with the terms of the license agreement     -
  they entered into with Yega Yazilim.                                        -
                                                                              -
  Author:  Ahmet Dogramaci                                                    -
  Date:    2021-09-10                                                         -
  ----------------------------------------------------------------------------->

<template>
  <b-container style="margin-top: 70px">
    <b-row>
      <b-col>
        <b-card no-body no-header>
          <b-card-header>
            <div class="text-center">
              <h5 class="font-weight-bold"> Quote Summary</h5>
            </div>
          </b-card-header>
          <b-table-lite small
                        borderless
                        striped
                        stacked="lg"
                        class="mb-0"
                        :items="sorted_rows"
                        :fields="fields">
            <template v-slot:cell(part_number)="data">
              {{ data.item.code }}
            </template>
            <template v-slot:cell(part_description)="data">
              {{ data.item.name }}<br>
              <b-button variant="success" size="sm"
                        :to="{name:'reconfigure_bto_path',params:{quote_version_id:quote_version_id,quote_part_id:quote_part_id,quote_product_id:data.item.product.id}}"
                        v-if="data.item.product_detail === undefined">
                Reconfigure
              </b-button>
            </template>
            <template v-slot:cell(quantity)="data" v-if="quantity_visible">
              <b-dropdown variant="primary" :text="quantityLabel(data.item.product)">
                <b-dropdown-item v-for="option in quantity_options" @click="handleQuantityChange(data.item.product, option.key)">{{option.label}}</b-dropdown-item>
              </b-dropdown>
            </template>
            <template v-slot:cell(msrp_price)="data">
              {{ formatCurrency(data.item.msrp_price) }}
            </template>
            <template v-slot:cell(partner_price)="data" v-if="your_price_visible">
              {{ formatCurrency(data.item.partner_price) }}
            </template>
            <template v-slot:cell(actions)="data">
              <b-button variant="danger" size="sm" @click="removeItem(data.item)">
                Remove
              </b-button>
            </template>
          </b-table-lite>
          <b-card-footer>
            <div class="text-center">
              <b-button variant="primary" size="lg" :to="{name:'quote_request_path'}" class="mr-5">Request A Quote</b-button>
              <!-- b-button variant="primary" size="lg" @click="handleQuoteLetter">View Quote Letter</b-button -->
            </div>
          </b-card-footer>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import Yega1DataSourceItem from "../yega/yega1/yega1-data-source-item.vue";
import Yega1CardForm from "../yega/yega1/yega1-card-form.vue";
import YesNo from "../../enums/yes-no";
import useCurrencyFormatter from "../../compositions/use-currency-formatter";

export default {
  name: "quote-summary",
  components: {
    Yega1CardForm,
    Yega1DataSourceItem
  },
  props:{
    hasYourPrice:{
      type: Boolean,
      default:false
    },
    role:{
      type: String
    },
  },
  setup(){
    const { formatCurrency } = useCurrencyFormatter();
    return {
      formatCurrency
    };
  },
  computed:{
    quote_part_id(){
      return this.CurrentUserStore.user.current_quote_part_id;
    },
    sorted_rows(){
      return this.rows.sort((row1,row2)=>{
        if(row1.product.index < row2.product.index){
          return -1;
        }else if(row1.product.index > row2.product.index){
          return 1;
        }else{
          return 0;
        }
      });
    },
    quote_version_id(){
     return this.CurrentUserStore.user.current_quote_version_id
    },
    your_price_visible(){
      return false;
    },
    quantity_visible(){
      return false;
    },
  },
  data(){
    let fields = [
      {key: 'part_number', label: 'Part Number'},
      {key: 'part_description', label: 'Description '},
      {key: 'msrp_price', label: 'MSRP '},
    ];
    if(this.your_price_visible){
      fields.push(
        {key: 'partner_price', label: 'Your Price '}
      )
    }
    if(this.quantity_visible){
      fields.push(
          {key: 'quantity', label: 'Quantity'}
      )
    }
    fields.push(
        {key: 'actions', label: ''}
    );
    return {
      CurrentUserStore:this.$store.state.CurrentUserStore,
      quotePart:null,
      rows: [],
      fields: fields,
      quantity_options:[
        {key:'1',label:'1-10'},
        {key:'11',label:'11-25'},
        {key:'26',label:'26-50'}
      ]
    };
  },
  created(){
    this.$store.dispatch('CurrentUserStore/show',{show_current_quote_id:'YES'})
        .then((item)=>{
          this.loadQuotePart();
        })
        .catch((error)=>{alert(error.response ? error.response.data : error);});
  },
  methods:{
    loadQuotePart(){
      this.$store.dispatch('QuotePartsStore/show',this.quote_part_id)
          .then(this.handleItemLoaded)
          .catch((error)=>{alert(error.response ? error.response.data : error);});
    },
    handleItemLoaded(item){
      this.quotePart = item;
      this.arrangeRows(item);
    },
    arrangeRows(item){
      this.rows = [];
      item.quote_products.forEach((quote_product)=>{
        if (this.isAccessory(quote_product)) {
          quote_product.quote_product_details.forEach((quote_product_detail) => {
            this.rows.push({
              product: quote_product,
              product_detail: quote_product_detail,
              attribute_store:quote_product_detail.attribute_store,
              code: quote_product_detail.code,
              name: quote_product_detail.name,
              msrp_price: this.productPrice(quote_product_detail, 'esup'),
              partner_price: this.productPrice(quote_product_detail, 'partner-price')
            });
          });
        } else {
          this.rows.push({
            product: quote_product,
            attribute_store:quote_product.attribute_store,
            code: quote_product.attribute_store['standard_quote_lookedup_part_number'],
            name: quote_product.attribute_store['standard_quote_product_description'],
            msrp_price: this.productPrice(quote_product, 'product_esup'),
            partner_price: this.productPrice(quote_product, 'product_partner_price')
          });
        }
      })
    },
    isAccessory(quote_product){
      return quote_product.attribute_store['standard_quote_is_accessory'] === YesNo.YES;
    },
    productPrice(quote_object,price_name){
      if(!quote_object.calculated_price_transformation_values){
        debugger;
      }
      let price_object = quote_object
          .calculated_price_transformation_values
          .find((price_object)=>{
            return price_object.name === price_name;
          });
      if(price_object){
        return price_object.value;
      }
    },
    removeItem(data){
      if(data.product_detail !== undefined){
        this.removeProductDetail(data);
      }else{
        this.removeProduct(data.product);
      }
    },
    removeProduct(item){
      if(!confirm('Are you sure you would like to remove?')){
        return;
      }
      this.$store
          .dispatch('QuoteProductsStore/destroy', item.id)
          .then(()=>{
            this.loadQuotePart();
          })
          .catch((error)=>{alert(error.response ? error.response.data : error);});
    },
    removeProductDetail(data){
      if(data.product.quote_product_details.length ===1){
        this.removeProduct(data.product);
      }else{
        if(!confirm('Are you sure you would like to remove?')){
          return;
        }
        this.$store
            .dispatch('QuoteProductDetailsStore/destroy', data.product_detail.id)
            .then(()=>{
              this.loadQuotePart();
            })
            .catch((error)=>{alert(error.response ? error.response.data : error);});
      }
    },
    handleQuoteLetter(){
      this.$store.dispatch('QuotePublishingStore/show',{quote_version_id:this.quote_version_id})
          .then((quote_publishing)=>{
            window.open('quote/views/'+quote_publishing.identifier);
          })
          .catch((error)=>{alert(error.response ? error.response.data : error);});

    },
    quantityLabel(quoteProduct){
      for (const option of this.quantity_options) {
        if (option.key === quoteProduct.quantity) {
          return option.label;
        }
      }
      return null;
    },
    handleQuantityChange(quoteProduct, quantity){
      quoteProduct.quantity = quantity;
      this.$store
          .dispatch('QuoteProductsStore/update', {
            id: quoteProduct.id,
            cfg_template_version_id: quoteProduct.cfg_template_version_id,
            quantity: quoteProduct.quantity
          })
          .then(()=>{
            this.loadQuotePart();
          })
          .catch((error)=>{alert(error.response ? error.response.data : error);});
    }
  }
}
</script>

<style scoped>

</style>
